import React, { useEffect, useState } from "react";
import { Modal, Button, Form } from "react-bootstrap";
import "./invite-user.scss";
import { useAuth } from "../../utility/use-auth";
import { auth, db } from "../../firebase/auth.firebase";
import { getIdToken } from "firebase/auth";
import { createUser, getUserCount, inviteUser, updateUserRole } from "../../services/api.service";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faClose, faWarning } from "@fortawesome/free-solid-svg-icons";
import LoadingComponent from "../../components/loading/loading.component";
import config from "../../config";
import { ProfileModel } from "../../model/profile.model";
import { TotalUserCountModel } from "../../model/total-users.model";
import { addDoc, collection, serverTimestamp } from "firebase/firestore";

const InviteUser = ({ show, onClose, onComplete, isEdit, profileEdit, onCompleteEdit }: any) => {
    const { user } = useAuth();
    const [isSending, setIsSending] = useState(false);
    const [email, setEmail] = useState("");
    const [role, setRole] = useState<string>('Staff');
    const [isError, setIsError] = useState(false);
    const [errorMessage, setErrorMessage] = useState("");
    const [isEmailError, setIsEmailError] = useState(false);
    const [profileEditMod, setProfileEditMod] = useState<ProfileModel>();

    useEffect(() => {
        if (isEdit) {
            setProfileEditMod(profileEdit)
        }
    }, [isEdit])

    useEffect(() => {
        if (profileEditMod) {
            if (profileEditMod.email) {
                setEmail(profileEditMod.email);
            }
            if (profileEditMod.role) {
                setRole(profileEditMod.role);
            }
        }
    }, [profileEditMod])
    const updateRole = async () => {
        if (email && role) {
            setIsSending(true);
            if (profileEditMod) {
                const result = await updateUserRole(profileEditMod.uuid, role);
                onCompleteEdit(email, role);
                onClose();
            }

        } else {
            alert("Please enter an email address.");
        }
    };
    const handleSendInvite = async () => {
        if (email && role) {
            if (!validateEmail(email)) {
                return setIsEmailError(true);
            }
            setIsSending(true);
            if (auth.currentUser) {
                const user = auth.currentUser; // Get the currently signed-in user
                if (!user) {
                    throw new Error('ไม่พบผู้ใช้งานในระบบ');
                }

                // Fetch the ID token (pass `true` to force refresh if needed)
                const idToken = await getIdToken(user, true);
                getUserCount().then((resUserCount: any) => {

                    if (resUserCount) {
                        const result = resUserCount as TotalUserCountModel;
                        if (role.includes("Admin") && result.totalAdmins < config.users.admin) {
                            createUser(email, role, idToken).then((res: any) => {
                                if (res) {
                                    inviteUser(email).then((res: any) => {
                                        if (res.success) {
                                            onComplete(email, role);
                                            onClose();
                                        }
                                    }).catch((error) => {
                                        if (!auth.currentUser) return; // Ensure user is logged in before logging out
                                        const user = auth.currentUser;
                                        const logRef = collection(db, "logs");
                                        addDoc(logRef, {
                                            timestamp: serverTimestamp(),
                                            user_id: user.uid,
                                            user_email: user.email,
                                            action_type: "INVITE",
                                            error: { email: email, message: error }
                                        });
                                    })

                                }
                            }).catch((error) => {
                                if (error.response.data.error) {
                                    const message = error.response.data.error;
                                    if (message.includes("The email address is already in use by another account.")) {
                                        setErrorMessage("ขออภัย, มีอีเมลนี้ในระบบแล้ว")
                                        if (!auth.currentUser) return; // Ensure user is logged in before logging out
                                        const user = auth.currentUser;
                                        const logRef = collection(db, "logs");
                                        addDoc(logRef, {
                                            timestamp: serverTimestamp(),
                                            user_id: user.uid,
                                            user_email: user.email,
                                            action_type: "INVITE",
                                            error: { email: email, message: "ขออภัย, มีอีเมลนี้ในระบบแล้ว" }
                                        });
                                    }
                                }


                                setIsSending(false);
                                setIsError(true);
                            })
                        } else if (role.includes("Admin") && result.totalAdmins == config.users.admin) {
                            setIsSending(false);
                            setIsError(true);
                            setErrorMessage("ไม่สามารถเพิ่มผู้ใช้งานได้ เนื่องจากเกินจำนวนที่ระบุ Admin: "+config.users.admin+"/"+config.users.admin);
                            if (!auth.currentUser) return; // Ensure user is logged in before logging out
                            const user = auth.currentUser;
                            const logRef = collection(db, "logs");
                            addDoc(logRef, {
                                timestamp: serverTimestamp(),
                                user_id: user.uid,
                                user_email: user.email,
                                action_type: "INVITE",
                                error: { email: email, message: "ไม่สามารถเพิ่มผู้ใช้งานได้ เนื่องจากเกินจำนวนที่ระบุ Admin: "+config.users.admin+"/"+config.users.admin }
                            });
                        }

                        if (role.includes("Staff") && result.totalStaff < config.users.staff) {
                            createUser(email, role, idToken).then((res: any) => {
                                if (res) {
                                    inviteUser(email).then((res: any) => {
                                        if (res.success) {
                                            onComplete(email, role);
                                            onClose();
                                        }
                                    }).catch((error) => {
                                        setIsSending(false);
                                        setIsError(true);
                                        setErrorMessage("เกิดข้อผิดพลาด");
                                        if (!auth.currentUser) return; // Ensure user is logged in before logging out
                                        const user = auth.currentUser;
                                        const logRef = collection(db, "logs");
                                        addDoc(logRef, {
                                            timestamp: serverTimestamp(),
                                            user_id: user.uid,
                                            user_email: user.email,
                                            action_type: "INVITE",
                                            error: { email: email, message: error }
                                        });

                                    })

                                }
                            }).catch((error) => {
                                if (error.response.data.error) {
                                    const message = error.response.data.error;
                                    if (message.includes("The email address is already in use by another account.")) {
                                        setErrorMessage("ขออภัย, มีอีเมลนี้ในระบบแล้ว")
                                        setIsSending(false);
                                        setIsError(true);
                                        if (!auth.currentUser) return; // Ensure user is logged in before logging out
                                        const user = auth.currentUser;
                                        const logRef = collection(db, "logs");
                                        addDoc(logRef, {
                                            timestamp: serverTimestamp(),
                                            user_id: user.uid,
                                            user_email: user.email,
                                            action_type: "INVITE",
                                            error: { email: email, message: "ขออภัย, มีอีเมลนี้ในระบบแล้ว" }
                                        });
                                    }
                                }


                                setIsSending(false);
                                setIsError(true);
                            })
                        } else if (role.includes("Staff") && result.totalStaff == config.users.staff) {
                            setIsSending(false);
                            setIsError(true);
                            setErrorMessage("ไม่สามารถเพิ่มผู้ใช้งานได้ เนื่องจากเกินจำนวนที่ระบุ Staff: "+config.users.staff+"/"+config.users.staff);
                            if (!auth.currentUser) return; // Ensure user is logged in before logging out
                            const user = auth.currentUser;
                            const logRef = collection(db, "logs");
                            addDoc(logRef, {
                                timestamp: serverTimestamp(),
                                user_id: user.uid,
                                user_email: user.email,
                                action_type: "INVITE",
                                error: { email: email, message: "ไม่สามารถเพิ่มผู้ใช้งานได้ เนื่องจากเกินจำนวนที่ระบุ Staff: "+config.users.staff+"/"+config.users.staff }
                            });
                        }
                    }
                })

            }


        } else {
            alert("Please enter an email address.");
        }
    };

    const validateEmail = (email) => {
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (emailRegex.test(email)) {
            setIsError(false);
            setIsEmailError(false);
            return emailRegex.test(email);
        } else {
            setIsError(false);
            setIsEmailError(true);
            return emailRegex.test(email);
        }

    };
    return (
        <>
            <Modal show={show} onHide={onClose} className="invite-user-modal">

                <Modal.Body>
                    <FontAwesomeIcon icon={faClose} onClick={onClose} className="invite-user-close-icon" />
                    {
                        isSending ?
                            <LoadingComponent message={"ระบบกำลังส่งคำเชิญ"} /> :
                            <>
                                <Form>
                                    <span className="invite-user-title">{
                                        isEdit && profileEditMod ? "แก้ไขผู้ใช้งานเข้าสู่ระบบ" : "เพิ่มผู้ใช้งานเข้าสู่ระบบ"
                                    }</span>


                                    <Form.Group controlId="formEmail" className="invite-user-form-group-control">
                                        <Form.Control
                                            type="email"
                                            placeholder="ระบุอีเมล"
                                            value={email}
                                            disabled={(isEdit && profileEditMod) ? true : false}
                                            className="invite-user-form-input"
                                            onChange={(e) => setEmail(e.target.value)}
                                        />
                                    </Form.Group>
                                    {/* Role Dropdown */}
                                    <Form.Group controlId="formRole" className="invite-user-form-group-control">
                                        <Form.Label className="invite-user-form-label">เลือกบทบาท</Form.Label>
                                        <Form.Group className="invite-user-form-radio-grid">
                                            <Form.Check
                                                type="radio"
                                                id="roleAdmin"
                                                name="role"
                                                value="Admin"
                                                label="Admin"
                                                checked={role === "Admin"}
                                                onChange={(e) => setRole(e.target.value)}
                                            />
                                            <Form.Check
                                                type="radio"
                                                id="roleStaff"
                                                name="role"
                                                value="Staff"
                                                label="Staff"
                                                checked={role === "Staff"}
                                                onChange={(e) => setRole(e.target.value)}
                                            />
                                        </Form.Group>
                                    </Form.Group>
                                </Form>
                                {
                                    isError &&

                                    <>
                                        <div className="invite-user-error-control">
                                            <FontAwesomeIcon icon={faWarning} className="invite-user-error-icon"></FontAwesomeIcon>
                                            <span className="invite-user-error-text">{errorMessage} </span>
                                        </div>
                                    </>
                                }

                                {
                                    isEmailError &&

                                    <>
                                        <div className="invite-user-error-control">
                                            <FontAwesomeIcon icon={faWarning} className="invite-user-error-icon"></FontAwesomeIcon>
                                            <span className="invite-user-error-text">อีเมลรูปแบบไม่ถูกต้อง </span>
                                        </div>
                                    </>
                                }
                                <Button variant="primary" onClick={(isEdit && profileEditMod) ? updateRole : handleSendInvite} className="invite-user-button-submit">
                                    {isEdit && profileEditMod ? "แก้ไข" : "ส่งคำเชิญ"}
                                </Button>
                            </>

                    }

                </Modal.Body>
            </Modal>

        </>
    );
};

export default InviteUser;
